import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { _setAxios } from '../../lib/Helper';

async function fetchList() {

  return await _setAxios("ubudiyah/surat/dropdown", "GET")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        let label = <>{row.nomor}: {row.nama} ({row.jumlah_ayat})</>

        results.push({
          label: label,
          value: row.id,
        })
      });

      return results
    })
}

const SelectNomorSurat = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  return (
    <Select
      {...props}
      placeholder="Pilih surat"
      fetchOptions={fetchList}
      style={{
        width: '100%',
      }}
      options={options}
    />
  );
};
export default SelectNomorSurat;
